import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import logo from '../../res/logo_beta.png';

import './navbar.css';

function Navbar() {
  const [click, setClick] = useState(false);
  const [button, setButton] = useState(true);

  const handleClick = () => setClick(!click);
  const closeMobileMenu = () => setClick(false);

  const showButton = () => {
    if (window.innerWidth <= 960) {
      setButton(false);
    } else {
      setButton(true);
    }
  };

  useEffect(() => {
    showButton();
    window.addEventListener('resize', showButton);
    return () => window.removeEventListener('resize', showButton);
  }, []);

  return (
    <nav className='navbar'>
      <div className='navbar-container'>
        <Link to="/" className="logo-container" onClick={closeMobileMenu}>
          <img src={logo} alt="Logo" className="logo" />
          <span className="logo-name">ElMeta.cl</span>
        </Link>

        <div className='menu-icon' onClick={handleClick}>
          <i className={click ? 'fas fa-times' : 'fas fa-bars'} />
        </div>

        <ul className={click ? 'nav-menu active' : 'nav-menu'}>
          <li className='nav-item'>
            <a href="https://datosyleyendas.com/elo-myl" className='nav-links' onClick={closeMobileMenu}>
              <i className="fa-solid fa-arrow-up-right-dots"></i> ELO-MyL
            </a>
          </li>
          <li className='nav-item'>
            <Link to="/meta" className='nav-links' onClick={closeMobileMenu}>
              <i className="fa-solid fa-ranking-star"></i> Meta
            </Link>
          </li>
          <li className='nav-item'>
            <Link to="/crear" className='nav-links' onClick={closeMobileMenu}>
              <i className="fa-solid fa-hammer"></i> Construir Mazo
            </Link>
          </li>
          <li className='nav-item'>
            <a href="https://datosyleyendas.com/" className='nav-links' onClick={closeMobileMenu}>
              <i className="fa-solid fa-newspaper"></i> Artículos
            </a>
          </li>
          <li className='nav-item mobile-only'>
            <Link to="/contact" className='nav-links' onClick={closeMobileMenu}>
              <i className="fa-solid fa-comment-dots"></i> Comentarios
            </Link>
          </li>
        </ul>

        <Link to="/contact" className='boton-navbar desktop-only' onClick={closeMobileMenu}>
          Comentarios
        </Link>
      </div>
    </nav>
  );
}

export default Navbar;
